import { alwaysLog, devLog } from '@/utils/logger';

const SW_SCRIPT = '/drive-stream-sw.js?v=r2index1';

/**
 * 将当前 access_token 推给 Drive 流式 Service Worker（空字符串表示登出并清空 SW 内缓存）。
 */
export function postTokenToDriveStreamSw(token: string | null): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const ctrl = navigator.serviceWorker.controller;
  if (!ctrl) {
    devLog.log('[DriveStreamSW] 无 controller，跳过 SET_TOKEN（等待 SW 接管页面后自动同步）');
    return;
  }
  try {
    ctrl.postMessage({ type: 'SET_TOKEN', token: token ?? '' });
  } catch (e) {
    alwaysLog.warn('[DriveStreamSW] postMessage SET_TOKEN 失败', e);
  }
}

export async function registerDriveStreamServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }
  try {
    const reg = await navigator.serviceWorker.register(SW_SCRIPT, { scope: '/' });
    await navigator.serviceWorker.ready;
    return reg;
  } catch (e) {
    alwaysLog.error('[DriveStreamSW] register 失败', e);
    return null;
  }
}

/**
 * 注册 SW、等待接管，并把当前 token 下发到 SW（用于在加载流式媒体前调用）。
 */
export async function ensureDriveStreamSwReady(getToken: () => string | null): Promise<boolean> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return false;
  }
  try {
    await registerDriveStreamServiceWorker();
    const deadline = Date.now() + 8000;
    /* eslint-disable no-await-in-loop -- 轮询直到 SW 接管或超时 */
    while (!navigator.serviceWorker.controller && Date.now() < deadline) {
      await new Promise<void>(resolve => {
        setTimeout(resolve, 50);
      });
    }
    /* eslint-enable no-await-in-loop */
    const t = getToken();
    if (t) postTokenToDriveStreamSw(t);
    return Boolean(navigator.serviceWorker.controller);
  } catch (e) {
    alwaysLog.error('[DriveStreamSW] ensureDriveStreamSwReady 失败', e);
    return false;
  }
}
